var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 44.7667C45.7439 44.7667 50.4001 40.1104 50.4001 34.3667C50.4001 28.6229 45.7439 23.9667 40.0001 23.9667C34.2563 23.9667 29.6001 28.6229 29.6001 34.3667C29.6001 40.1104 34.2563 44.7667 40.0001 44.7667Z",
    stroke: "#276E91",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0668 28.3C18.6334 -0.566699 61.4001 -0.533365 67.9334 28.3333C71.7668 45.2666 61.2334 59.6 52.0001 68.4666C45.3001 74.9333 34.7001 74.9333 27.9668 68.4666C18.7668 59.6 8.23342 45.2333 12.0668 28.3Z",
    stroke: "#45B14A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation1);
export default __webpack_public_path__ + "static/media/location1.bc332ba097f13056ec43b065eb9f0849.svg";
export { ForwardRef as ReactComponent };